// extracted by mini-css-extract-plugin
export default {"h2":"FAQ_h2__yTBc8","accordion-button":"FAQ_accordion-button__jb-qk","collapsed":"FAQ_collapsed__DiGKi","accordion-item":"FAQ_accordion-item__kpUoj"};